module.exports = __webpack_public_path__ + "img/estilo.e176f4fd.png";